import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import { Provider } from 'react-redux';
import { Settings } from 'luxon';

import { DEFAULT_LOCALE, DEFAULT_TIMEZONE } from 'config/defaults';
import { saveState } from 'service/storage';

import App from './app';
import store from './app/redux/store';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// ✅ Add the polyfill here, right at the top
if (typeof structuredClone === 'undefined') {
  window.structuredClone = (obj) => JSON.parse(JSON.stringify(obj));
}

store.subscribe(() => {
    saveState(store.getState());
});

Settings.defaultLocale = DEFAULT_LOCALE;
Settings.defaultZone = DEFAULT_TIMEZONE;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store} >
      <App />
  </Provider>
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration && registration.waiting) {
      console.log('Hay una nueva version de Facturoo, recargando pagina...')
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });

      // Reload the page to load the new content
      window.location.reload();
    }
  },
});
